/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

export default {
  locale: 'de',
  Pagination: {
    items_per_page: '/ Seite',
    jump_to: 'Gehe zu',
    jump_to_confirm: 'bestätigen',
    page: '',
    prev_page: 'Vorherige Seite',
    next_page: 'Nächste Seite',
    prev_5: '5 Seiten zurück',
    next_5: '5 Seiten vor',
    prev_3: '3 Seiten zurück',
    next_3: '3 Seiten vor'
  },
  DatePicker: {
    lang: {
      placeholder: 'Datum auswählen',
      yearPlaceholder: 'Jahr auswählen',
      quarterPlaceholder: 'Quartal auswählen',
      monthPlaceholder: 'Monat auswählen',
      weekPlaceholder: 'Woche auswählen',
      rangePlaceholder: ['Startdatum', 'Enddatum'],
      rangeYearPlaceholder: ['Startjahr', 'Endjahr'],
      rangeMonthPlaceholder: ['Startmonat', 'Endmonat'],
      rangeWeekPlaceholder: ['Startwoche', 'Endwoche'],
      locale: 'de_DE',
      today: 'Heute',
      now: 'Jetzt',
      backToToday: 'Zurück zu Heute',
      ok: 'OK',
      clear: 'Zurücksetzen',
      month: 'Monat',
      year: 'Jahr',
      timeSelect: 'Zeit wählen',
      dateSelect: 'Datum wählen',
      weekSelect: 'Woche wählen',
      monthSelect: 'Wähle einen Monat',
      yearSelect: 'Wähle ein Jahr',
      decadeSelect: 'Wähle ein Jahrzehnt',
      yearFormat: 'YYYY',
      dateFormat: 'D.M.YYYY',
      dayFormat: 'D',
      dateTimeFormat: 'D.M.YYYY HH:mm:ss',
      monthBeforeYear: true,
      previousMonth: 'Vorheriger Monat (PageUp)',
      nextMonth: 'Nächster Monat (PageDown)',
      previousYear: 'Vorheriges Jahr (Ctrl + left)',
      nextYear: 'Nächstes Jahr (Ctrl + right)',
      previousDecade: 'Vorheriges Jahrzehnt',
      nextDecade: 'Nächstes Jahrzehnt',
      previousCentury: 'Vorheriges Jahrhundert',
      nextCentury: 'Nächstes Jahrhundert'
    },
    timePickerLocale: {
      placeholder: 'Zeit auswählen',
      rangePlaceholder: ['Startzeit', 'Endzeit']
    }
  },
  TimePicker: {
    placeholder: 'Zeit auswählen'
  },
  Calendar: {
    lang: {
      placeholder: 'Datum auswählen',
      yearPlaceholder: 'Jahr auswählen',
      quarterPlaceholder: 'Quartal auswählen',
      monthPlaceholder: 'Monat auswählen',
      weekPlaceholder: 'Woche auswählen',
      rangePlaceholder: ['Startdatum', 'Enddatum'],
      rangeYearPlaceholder: ['Startjahr', 'Endjahr'],
      rangeMonthPlaceholder: ['Startmonat', 'Endmonat'],
      rangeWeekPlaceholder: ['Startwoche', 'Endwoche'],
      locale: 'de_DE',
      today: 'Heute',
      now: 'Jetzt',
      backToToday: 'Zurück zu Heute',
      ok: 'OK',
      clear: 'Zurücksetzen',
      month: 'Monat',
      year: 'Jahr',
      timeSelect: 'Zeit wählen',
      dateSelect: 'Datum wählen',
      weekSelect: 'Woche wählen',
      monthSelect: 'Wähle einen Monat',
      yearSelect: 'Wähle ein Jahr',
      decadeSelect: 'Wähle ein Jahrzehnt',
      yearFormat: 'YYYY',
      dateFormat: 'D.M.YYYY',
      dayFormat: 'D',
      dateTimeFormat: 'D.M.YYYY HH:mm:ss',
      monthBeforeYear: true,
      previousMonth: 'Vorheriger Monat (PageUp)',
      nextMonth: 'Nächster Monat (PageDown)',
      previousYear: 'Vorheriges Jahr (Ctrl + left)',
      nextYear: 'Nächstes Jahr (Ctrl + right)',
      previousDecade: 'Vorheriges Jahrzehnt',
      nextDecade: 'Nächstes Jahrzehnt',
      previousCentury: 'Vorheriges Jahrhundert',
      nextCentury: 'Nächstes Jahrhundert'
    },
    timePickerLocale: {
      placeholder: 'Zeit auswählen',
      rangePlaceholder: ['Startzeit', 'Endzeit']
    }
  },
  global: {
    placeholder: 'Bitte auswählen'
  },
  Table: {
    filterTitle: 'Filter-Menü',
    filterConfirm: 'OK',
    filterReset: 'Zurücksetzen',
    filterEmptyText: 'Keine Filter',
    emptyText: 'Keine Daten',
    selectAll: 'Selektiere Alle',
    selectInvert: 'Selektion Invertieren',
    selectionAll: 'Wählen Sie alle Daten aus',
    sortTitle: 'Sortieren',
    expand: 'Zeile erweitern',
    collapse: 'Zeile reduzieren',
    triggerDesc: 'Klicken zur absteigenden  Sortierung',
    triggerAsc: 'Klicken zur aufsteigenden Sortierung',
    cancelSort: 'Klicken zum Abbrechen der Sortierung'
  },
  Modal: {
    okText: 'OK',
    cancelText: 'Abbrechen',
    justOkText: 'OK'
  },
  Popconfirm: {
    okText: 'OK',
    cancelText: 'Abbrechen'
  },
  Transfer: {
    titles: ['', ''],
    searchPlaceholder: 'Suchen',
    itemUnit: 'Eintrag',
    itemsUnit: 'Einträge',
    remove: 'Entfernen',
    selectCurrent: 'Aktuelle Seite auswählen',
    removeCurrent: 'Aktuelle Seite abwählen',
    selectAll: 'Alle Daten auswählen',
    removeAll: 'Alle Daten abwählen',
    selectInvert: 'Aktuelle Auswahl invertieren'
  },
  Upload: {
    uploading: 'Hochladen...',
    removeFile: 'Datei entfernen',
    uploadError: 'Fehler beim Hochladen',
    previewFile: 'Dateivorschau',
    downloadFile: 'Download-Datei'
  },
  Empty: {
    description: 'Keine Daten'
  },
  Text: {
    edit: 'Bearbeiten',
    copy: 'Kopieren',
    copied: 'Kopiert',
    expand: 'Erweitern'
  },
  PageHeader: {
    back: 'Zurück'
  }
};
